export default "__VITE_ASSET__D$jevZ2S__"